import { SearchApiResponse, SearchData, SearchQueryParams } from '@/types/search.types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const globalSearchApi = {
  search: async (params: SearchQueryParams): Promise<SearchData> => {
    // Default values matching the user's provided curl request
    const defaultParams: Partial<SearchQueryParams> = {
      cache: true,
      limit_per_type: 20,
      page: 1,
      keep_closed_markets: 0,
      sort: 'volume_24hr',
      ascending: false,
      search_tags: true,
      search_profiles: true,
      optimized: false,
    };

    const response = await axiosClient.get<SearchApiResponse>(API_ENDPOINTS.GLOBAL_SEARCH, {
      params: { ...defaultParams, ...params },
    });

    if (response.data?.success && response.data?.data?.data) {
      return response.data.data.data;
    }

    return {
      events: [],
      profiles: [],
      tags: [],
      hasMore: false,
      totalResults: 0,
    };
  },
};
